import CardKelas from "../../components/status/CardKelas";
import Loading from "../../components/Loading";
import ProtectedRoute from "../../components/ProtectedRoute";
import useStatus from "../../service/status/useStatus";
import AppContext from "../../context/appContext";
import { useContext } from "react";

function Index() {
  const { userData, auth } = useContext(AppContext);
  const { data, selected, fetching, handleChange } = useStatus(userData);
  const itemDropdown = ["Terbaru", "Terdahulu"];

  return (
    <main className="mx-auto flex h-full w-full max-w-[1280px] flex-col gap-5 px-2 pt-40 pb-10 md:px-8 lg:px-16">
      <p className="font-nunito text-3xl font-bold">Status Kelas</p>
      <div className="items-center">
        <label htmlFor="sortBy" className="font-nunito text-lg font-semibold">
          Urutkan berdasarkan :{" "}
        </label>
        <select
          name="sortBy"
          className="cursor-pointer font-nunito text-lg font-semibold"
          defaultValue={selected}
          onChange={handleChange}
        >
          {itemDropdown.map((item, i) => (
            <option key={i} value={item}>
              {item}
            </option>
          ))}
        </select>
      </div>
      <div className="grid grid-cols-1 gap-5 pb-10">
        {data && data.length ? (
          data.map((item, i) => (
            <div key={i}>
              <CardKelas
                status={item.status}
                test_link={item.test_link}
                test_fee={item.test_fee}
                test_date={item.test_date}
                test_score={item.test_score}
                class_fee={item.class_fee}
                class_name={item.class_name}
                ch_name={item.ch_name}
                class_id={item.class_id}
                ch_id={item.ch_id}
                auth={auth}
              />
            </div>
          ))
        ) : (
          <p className="font-nunito text-lg font-semibold">
            Anda belum pernah membeli sebuah kelas
          </p>
        )}
      </div>

      {fetching ? (
        <div className="fixed top-0 left-0 z-[150] flex h-screen w-screen items-center justify-center bg-black bg-opacity-10">
          <Loading fillcolor={"#EA374C"} />
        </div>
      ) : null}
    </main>
  );
}
export default ProtectedRoute(Index);
